export default "__VITE_ASSET__CXw0hMwf__"